import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Row, Select, Space,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Material } from '../../../../models/material'
import { isTcmRecipeCategory, RecipeCategory } from '../../../../models/recipe'
import { Checks, Settings } from '../../../../models/setting'
import { getNewMLCodeCompletions, ItemCompletionType } from '../../../completion/completionSlice'
import { selectBooleanSetting } from '../../../settings/settingsSlice'
import { RecipeItemFieldInput } from '../components/RecipeItemFieldInput'
import { RecipeItemInput } from '../components/RecipeItemInput'
import styles from './RecipeItemModal.module.css'
import { ThemeContext } from "../../../../theme/ThemeContext";
import { RootDispatch } from '../../../../app/store'
import { selectSettings } from '../../../user/setting/settingSlice'
import { selectEdition } from '../../../../app/applicationSlice'
import { getNewAutoChangePriceDrugCount, getNewAutoChangePriceSplitDrugCount, getNewAutoChangePriceSplitUseDays, getNewAutoChangePriceUseDays, getOldAutoChangePriceDrugCount, getOldAutoChangePriceSplitDrugCount, getOldAutoChangePriceSplitUseDays, getOldAutoChangePriceUseDays } from '../../../../models/RecipeItemAutoChangePrice'
import { unwrapResult } from '@reduxjs/toolkit'
interface RecipeItemModalProps {
  discountFlag?: any //医嘱处方
  potionType?: number
  category?: RecipeCategory
  material?: Material
  insuranceCode?: any
  onChange?: (material: Material) => void
  onOk?: () => void
}

export const RecipeItemModal = ({
  discountFlag,
  potionType,
  category,
  material,
  insuranceCode,
  onChange,
  onCancel,
  onOk,
}: RecipeItemModalProps & ModalProps): ReactElement => {
  const [form] = Form.useForm()

  const { TextArea } = Input

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const countPerTipRef = useRef<any>()
  const slRef = useRef<any>()
  const buttonRef = useRef<HTMLElement>(null)

  const [doseUnitData, setDoseUnitData] = useState<any>([])

  const [accountUnitData, setAccountUnitData] = useState<any>([])

  const [doseUnitSelect, setDoseUnitSelect] = useState<any>()

  const [selectData, setSelectData] = useState<any>()

  const [loading, setLoading] = useState(false)

  const [current, setCurrent] = useState<Material | undefined>()

  const [isSplitModalVisibleMaterialsBean, setIsSplitModalVisibleMaterialsBean] = useState<any>()

  const settings = useSelector(selectSettings)

  const autoChangePriceAfter = useSelector(
    selectBooleanSetting(Settings.Recipe.AutoChangePriceAfter)
  )

  const useSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.UseSpecifiedBatch)
  )

  const ignoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.IgnoreStorage)
  )

  const tcmUseSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmUseSpecifiedBatch)
  )

  const tcmIgnoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmIgnoreStorage)
  )

  const allowedToChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.ChangePrice)
  )

  const [selectItems, setSelectItems] = useState<any>()

  const [isDoseUnitShiLiang, setIsDoseUnitShiLiang] = useState(false) // 剂量单位是否为"适量"

  const [completionType, setCompletionType] = useState(
    ItemCompletionType.Inventory
  )
  const NumberPattern = /^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/

  const NormalDosePattern = /([0-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/

  const layout = {
    labelCol: {
      flex: '5rem',
    },
  }

  useEffect(() => {
    if (category === RecipeCategory.Dispose) {
      // 口腔版原先的逻辑
      // if (hisVersion == 1) {
      //   // 诊疗 material?.drugType == 1
      //   if (material?.drugType == 1) {
      //     setCompletionType(ItemCompletionType.Treatment)
      //   } else {
      //     // 走材料的
      //     setCompletionType(ItemCompletionType.cureCheck)
      //   }
      // } else {
      // 走合并后的处置逻辑
      setCompletionType(ItemCompletionType.ZLCL)
      // }
    } else if (category !== RecipeCategory.Tcm && category !== RecipeCategory.TcmGranules) {
      // 诊疗 material?.drugType == 1
      if (material?.drugType == 1) {
        setCompletionType(ItemCompletionType.Treatment)
      } else {
        setCompletionType(ItemCompletionType.Auto)
      }
    } else {
      setCompletionType(ItemCompletionType.Auto)
    }
  }, [completionType, category, !!material])

  const handler = (e: KeyboardEvent) => {
    if (!isSplitModalVisibleMaterialsBean) {
      document.removeEventListener('keydown', handler)
      return
    }
    if (e.key === '1' || e.key === '2') {
      setIsSplitModalVisibleMaterialsBean(null)
      document.removeEventListener('keydown', handler)
      setCurrent({
        ...isSplitModalVisibleMaterialsBean,
        splitTag: e.key === '1' ? 1 : 0,
        retailPrice: e.key === '1' ? isSplitModalVisibleMaterialsBean?.splitPrice : isSplitModalVisibleMaterialsBean?.retailPrice,
        accountUnit: e.key === '1' ? isSplitModalVisibleMaterialsBean?.splitUnit : isSplitModalVisibleMaterialsBean?.accountUnit
      })

      setTimeout(() => {
        if (isTcmRecipeCategory(category)) {
          countPerTipRef?.current?.select()
        } else {
          slRef?.current?.select()
        }
      }, 300)

    }
  }

  useEffect(() => {
    if (isSplitModalVisibleMaterialsBean) {
      document.addEventListener('keydown', handler)
      setTimeout(() => {
        buttonRef.current?.focus()
      }, 300)
    } else {
      document.removeEventListener('keydown', handler)
    }
    return () => {
      document.removeEventListener('keydown', handler)
    }
  }, [isSplitModalVisibleMaterialsBean])

  useEffect(() => {
    setCurrent(material)
    setSelectData(material)
    // 剂量单位为"适量"时，清空剂量并置灰
    if (material?.doseUnit === '适量') {
      setIsDoseUnitShiLiang(true)
    } else {
      setIsDoseUnitShiLiang(false)
    }
  }, [material])

  useEffect(() => {
    const flag: any = !!material
    localStorage?.setItem('editMedicalVisible', flag)
  }, [material])

  useEffect(() => {
    if (material)
      form.setFieldsValue({
        ...current,
        normalDose: current?.normalDose == -1 ? '' : current?.normalDose,
        retailPrice: current?.retailPrice
          ? Number(current?.retailPrice)?.toFixed(5)
          : '0.00000',
        originalPrice: current?.originalPrice
          ? Number(current?.originalPrice)?.toFixed(5)
          : '0.00000',
        discount: current?.discount
          ? (Number(current?.discount))?.toFixed(0)
          : '-',
      })
  }, [current, material])

  const getDoseUnitData = (v: any) => {
    // dispatch(getNewMLCodeCompletions(materialsCatalogId))
    //   .then(unwrapResult)
    //   .then((v: any) => {
    let list: any = []

    if (v?.materialsCategory == 0) {
      // 中药药品 : 最小包装单位 包装单位
      if (v?.drugCategory === '中药材/饮片') {
        if (v?.splitTag == 1) {
          list = [
            {
              name: '适量',
            },
            v?.minPackUnit && {
              name: v?.minPackUnit,
            },
          ].filter(Boolean);
        } else {
          list = [
            {
              name: '适量',
            },
            v?.minPackUnit && {
              name: v?.minPackUnit,
            },
            v?.accountUnitML && {
              name: v?.accountUnitML,
            }
          ].filter(Boolean);
        }
      } else {
        // 非中药药品 : 容量单位 成分含量单位 最小包装单位 包装单位
        if (v?.splitTag == 1) {
          list = [
            {
              name: '适量',
            },
            v?.capacityUnit && {
              name: v?.capacityUnit,
            },
            v?.componentsUnit && {
              name: v?.componentsUnit,
            },
            v?.minPackUnit && {
              name: v?.minPackUnit,
            },

          ].filter(Boolean);
        } else {
          list = [
            {
              name: '适量',
            },
            v?.capacityUnit && {
              name: v?.capacityUnit,
            },
            v?.componentsUnit && {
              name: v?.componentsUnit,
            },
            v?.minPackUnit && {
              name: v?.minPackUnit,
            },
            v?.accountUnitML && {
              name: v?.accountUnitML,
            }
          ].filter(Boolean);
        }
      }
    } else {
      // 材料/器械/其他 : 最小包装单位 包装单位
      list = [
        {
          name: '适量',
        },
        v?.minPackUnit && {
          name: v?.minPackUnit,
        },
        v?.accountUnitML && {
          name: v?.accountUnitML,
        }
      ].filter(Boolean);
    }

    // 关键：过滤掉 false、null、undefined、空字符串
    const uniqueMap = new Map();
    list.forEach((item: any) => {
      uniqueMap.set(item.name, item);
    });
    list = Array.from(uniqueMap.values());

    setDoseUnitData(
      list?.map((item: any) => ({
        name: item.name,
      }))
    )
    setDoseUnitSelect(v?.doseUnit)
    // })

  }

  const getAccountUnitData = (v: any) => {
    let list: any = []
    list = [
      v?.minPackUnit && {
        name: v?.minPackUnit,
      },
      v?.accountUnitML && {
        name: v?.accountUnitML,
      }
    ].filter(Boolean);

    // 关键：过滤掉 false、null、undefined、空字符串
    const uniqueMap = new Map();
    list.forEach((item: any) => {
      uniqueMap.set(item.name, item);
    });
    list = Array.from(uniqueMap.values());

    setAccountUnitData(
      list?.map((item: any) => ({
        name: item.name,
      }))
    )
  }

  const required = {
    rules: [
      {
        required: true,
        message: '请输入必填项',
      },
    ],
  }

  const normalDoseRequired = {
    rules: [
      {
        required: !isDoseUnitShiLiang,
        message: '请输入必填项',
      },
    ],
  }

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (process.env.node_env === 'development') {
        console.warn('Global key handler installed.')
      }
      if (e.isComposing || e.code !== 'Space') {
        return
      }
      form.submit()
    }

    document.addEventListener('keydown', onKeyDown)

    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  useEffect(() => {
    if (!material) {
      setDoseUnitData([])
    }
  }, [material])

  return (
    <>
      <Modal
        title={
          completionType == ItemCompletionType.ZLCL ? '编辑诊疗/材料' : material?.drugType == 0
            ? '编辑药品'
            : '编辑诊疗'
        }
        width={800}
        visible={!!material}
        onCancel={(e) => {
          form.resetFields()
          setIsDoseUnitShiLiang(false)
          onCancel && onCancel(e)
        }}
        onOk={() => {
          form.resetFields()
          setIsDoseUnitShiLiang(false)
          onOk && onOk()
        }}
        footer={null}
        className={styles.editModal}
      >
        <Form
          form={form}
          autoComplete='off'
          requiredMark={false}
          colon={false}
          onFinish={(values) => {
            if (values?.name != selectData?.name) {
              notification.info({
                message: '商品名称错误，请修改后再保存',
              })
              return
            }
            setLoading(true)
            const tips = selectItems?.filter(
              (v: any) => v?.name == values?.name
            )
            if (isTcmRecipeCategory(category)) {
              if (values?.countPerTip == 0) {
                notification.error({
                  message: '每帖数量不可为 0',
                  duration: 2,
                })
                setLoading(false)
              } else {
                if (tips?.length || values?.name == current?.name) {
                  onChange &&
                    onChange({
                      ...current,
                      ...values,
                      normalDose: values?.doseUnit == '适量' ? -1 : values?.normalDose,
                      id: material?.id,
                      discount: values?.discount,
                      // originalPrice: undefined,
                    })
                  onOk && onOk()
                  setLoading(false)
                } else {
                  notification.info({
                    message: '商品名称错误，请修改后再保存',
                  })
                  setLoading(false)
                }
              }
            } else {
              if (values?.drugCount == 0) {
                notification.error({
                  message: '每帖数量不可为 0',
                  duration: 2,
                })
                setLoading(false)
              } else {
                if (tips?.length || values?.name == current?.name) {
                  onChange &&
                    onChange({
                      ...current,
                      ...values,
                      normalDose: values?.doseUnit == '适量' ? -1 : values?.normalDose,
                      id: material?.id,
                      discount: values?.discount,
                      // originalPrice: undefined,
                    })
                  onOk && onOk()
                  setLoading(false)
                } else {
                  notification.info({
                    message: '商品名称错误，请修改后再保存',
                  })
                  setLoading(false)
                }
              }
            }
          }}
          className={styles.form}
        >
          <Row gutter={20}>
            <Col span={12}>
              <Form.Item
                {...layout}
                name='name'
                label='商品名称'
                rules={[{ required: true }]}
              >
                <RecipeItemInput
                  placeholder={completionType != ItemCompletionType.Treatment ? (settings?.[Checks.YPSSFS] === '1' ? '名称/助记码/追溯码' : '名称/助记码/条形码') : '名称/助记码'}
                  type={completionType}
                  isRestrictUser={1} //是否限制用户
                  category={category}
                  insuranceCode={insuranceCode}
                  potionType={potionType}
                  isShowPageChange={true}
                  useSpecifiedBatch={
                    isTcmRecipeCategory(category)
                      ? tcmUseSpecifiedBatch
                      : useSpecifiedBatch
                  }
                  ignoreStorage={
                    isTcmRecipeCategory(category)
                      ? tcmIgnoreStorage
                      : ignoreStorage
                  }
                  filters={false}
                  onSelect={(m) => {
                    const originalPrice = m?.originalPrice ? m?.originalPrice : m?.retailPrice
                    setSelectData({ ...m, originalPrice })
                    if (m.splitTag === 1) {
                      // 拆零
                      setIsSplitModalVisibleMaterialsBean({ ...m, originalPrice, discount: m?.discount ? m?.discount : 100 });
                    } else {
                      setCurrent({
                        ...m,
                        originalPrice,
                        splitTag: 0,
                        groupNumber: form.getFieldValue('groupNumber'),
                        discount: m?.discount ? m?.discount : 100,
                      })
                      if (isTcmRecipeCategory(category)) {
                        countPerTipRef?.current?.select()
                      } else {
                        slRef?.current?.select()
                      }
                    }
                  }}
                  onItems={(v) => {
                    setSelectItems(v)
                  }}
                />
              </Form.Item>
            </Col>
            {!isTcmRecipeCategory(category) && category !== 13 && (
              <>
                <Col span={12}>
                  <Form.Item {...layout} name='groupNumber' label='组号'>
                    <Input />
                  </Form.Item>
                </Col>
                {material?.normalFrequency && material?.normalUsemethod ? (
                  <Col span={12}>
                    <Form.Item
                      {...layout}
                      name='normalFrequency'
                      label='频次'
                      rules={[
                        {
                          required: true,
                        },
                        {
                          max: 16,
                          message: '最长16位',
                        },
                      ]}
                    >
                      <RecipeItemFieldInput
                        field='normalFrequency'
                        noSize
                        recipeCategory={category}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}
              </>
            )}
            {(material?.normalFrequency && material?.normalUsemethod || completionType == ItemCompletionType.ZLCL) ? (
              <Col span={12}>
                <Form.Item
                  {...layout}
                  name='normalUsemethod'
                  label='用法'
                  rules={[
                    {
                      required: completionType == ItemCompletionType.ZLCL ? false : true,
                    },
                  ]}
                >
                  <RecipeItemFieldInput
                    field='normalUsemethod'
                    noSize
                    recipeCategory={category}
                  />
                </Form.Item>
              </Col>
            ) : (
              ''
            )}
            {isTcmRecipeCategory(category) ? (
              <Col span={12}>
                <Form.Item
                  {...layout}
                  name='countPerTip'
                  label='每帖数量 '
                  rules={[{ required: true }]}
                >
                  <Input ref={countPerTipRef} />
                </Form.Item>
              </Col>
            ) : (
              <>
                {completionType == ItemCompletionType.ZLCL ? <></> : material?.drugType == 0 ? (
                  <Col span={12}>
                    <Form.Item
                      {...layout}
                      name='useDays'
                      label='天数'
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}
                {
                  // material?.normalFrequency && material?.normalUsemethod 编辑诊疗时不需要
                  category !== 13 &&
                  material?.drugType == 0 && (
                    <Col span={12}>
                      <Form.Item
                        {...layout}
                        label='每次用量'
                        rules={[{ required: true }]}
                      >
                        <Row wrap={false} style={{ display: 'flex' }}>
                          <Form.Item name='normalDose' {...normalDoseRequired} noStyle>
                            <Input
                              disabled={isDoseUnitShiLiang}
                              style={{ flex: 1 }}
                              onChange={(e) => {
                                const normalDose: any = e.target.value  //每次用量
                                const count = form.getFieldValue('drugCount') || 1
                                const doseUnit = form.getFieldValue('doseUnit') //剂量单位
                                const normalUsemethod = form.getFieldValue('normalUsemethod') //用法
                                const doseFixJDJZ = (normalDose > 0 && (normalUsemethod?.indexOf("静滴") >= 0 || normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
                                const doseFixWH = (normalDose > 0 && normalUsemethod?.indexOf("雾化") >= 0) ? true : false;
                                const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS]

                                const doseConvert = Number(current?.doseConvert) != -1 && Number(current?.doseConvert) || 1
                                let drugCount: any = 0
                                let splitDrugCount: any = 0
                                if (autoChangePriceAfter) {
                                  if (normalDose && NormalDosePattern.test(normalDose) && current?.frequencyCalc && doseUnit != '适量') {
                                    if (settings?.[Checks.MLKG] == 1) {
                                      if (!doseUnit) {
                                        drugCount = count
                                        splitDrugCount = count
                                      } else {
                                        drugCount = getNewAutoChangePriceDrugCount('normalDose', selectData, doseUnit, doseFixJDJZ, doseFixWH, current?.frequencyCalc, normalDose, current.useDays, flag)
                                        splitDrugCount = getNewAutoChangePriceSplitDrugCount('normalDose', selectData, doseUnit, doseFixJDJZ, doseFixWH, current?.frequencyCalc, normalDose, current.useDays, flag)
                                      }
                                    } else {
                                      drugCount = getOldAutoChangePriceDrugCount('normalDose', doseFixJDJZ, current.useDays, '', normalDose, doseConvert, current?.frequencyCalc)
                                      splitDrugCount = getOldAutoChangePriceSplitDrugCount('normalDose', doseFixJDJZ, current.useDays, '', normalDose, current?.frequencyCalc)
                                    }
                                  } else {
                                    drugCount = count
                                    splitDrugCount = count
                                  }
                                  form.setFieldsValue({
                                    drugCount: current?.splitTag == 1 ? splitDrugCount : drugCount,
                                  })
                                  const data: any = {
                                    ...current,
                                    ...form.getFieldsValue(),
                                    normalDose: normalDose,
                                    drugCount,
                                  }
                                  setCurrent(data)
                                }
                              }}
                            />
                          </Form.Item>
                          <Form.Item name='doseUnit' noStyle>
                            {settings?.[Checks.MLKG] == 1 ?
                              <Select className={styles.doseUnitSelect}
                                onClick={() => {
                                  setDoseUnitData([])
                                  if (material?.materialsCatalogId) {
                                    getDoseUnitData(material)
                                  }
                                }}
                                onChange={(value) => {
                                  setDoseUnitSelect(value)
                                  console.log(value, 'doseUnitdoseUnitdoseUnit')
                                  if (value == '适量') {
                                    form.setFieldsValue({
                                      normalDose: '',
                                    })
                                    setIsDoseUnitShiLiang(true)
                                  }else{
                                    setIsDoseUnitShiLiang(false)
                                  }
                                  const normalDose: any = form.getFieldValue('normalDose') || ''  //每次用量
                                  const count = form.getFieldValue('drugCount') || 1
                                  const doseUnit = value //剂量单位
                                  const normalUsemethod = form.getFieldValue('normalUsemethod') //用法
                                  const doseFixJDJZ = (normalDose > 0 && (normalUsemethod?.indexOf("静滴") >= 0 || normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
                                  const doseFixWH = (normalDose > 0 && normalUsemethod?.indexOf("雾化") >= 0) ? true : false;
                                  const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS]

                                  const doseConvert = Number(current?.doseConvert) != -1 && Number(current?.doseConvert) || 1
                                  let drugCount: any = 0
                                  let splitDrugCount: any = 0
                                  if (autoChangePriceAfter) {
                                    if (normalDose && NormalDosePattern.test(normalDose) && current?.frequencyCalc && doseUnit != '适量') {
                                      if (settings?.[Checks.MLKG] == 1) {
                                        if (!doseUnit) {
                                          drugCount = count
                                          splitDrugCount = count
                                        } else {
                                          drugCount = getNewAutoChangePriceDrugCount('doseUnit', selectData, doseUnit, doseFixJDJZ, doseFixWH, current?.frequencyCalc, normalDose, current.useDays, flag)
                                          splitDrugCount = getNewAutoChangePriceSplitDrugCount('doseUnit', selectData, doseUnit, doseFixJDJZ, doseFixWH, current?.frequencyCalc, normalDose, current.useDays, flag)
                                        }
                                      } else {
                                        // drugCount = getOldAutoChangePriceDrugCount('doseUnit', doseFixJDJZ, current.useDays, '', normalDose, doseConvert, current?.frequencyCalc)
                                        // splitDrugCount = getOldAutoChangePriceSplitDrugCount('doseUnit', doseFixJDJZ, current.useDays, '', normalDose, current?.frequencyCalc)
                                      }
                                    } else {
                                      drugCount = count
                                      splitDrugCount = count
                                    }
                                    form.setFieldsValue({
                                      drugCount: current?.splitTag == 1 ? splitDrugCount : drugCount,
                                    })
                                    const data: any = {
                                      ...current,
                                      ...form.getFieldsValue(),
                                      normalDose: normalDose,
                                      drugCount,
                                    }
                                    setCurrent(data)
                                  }
                                }}
                              >
                                {doseUnitData?.map((item: any) => (
                                  <Select.Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Select.Option>
                                ))}
                              </Select> :
                              <RecipeItemFieldInput
                                field='doseUnit'
                                noSize
                                style={{ width: 36 }}
                                onChange={(v) => {
                                  if (v === '适量') {
                                    setIsDoseUnitShiLiang(true)
                                    form.setFieldsValue({ normalDose: '' })
                                  } else {
                                    setIsDoseUnitShiLiang(false)
                                  }
                                }}
                              />}
                          </Form.Item>
                        </Row>
                      </Form.Item>
                    </Col>
                  )
                }
                <Col span={12}>
                  <Form.Item
                    {...layout}
                    label='数量'
                    rules={[{ required: true }]}
                  >
                    <Row wrap={false} style={{ display: 'flex' }}>
                      <Form.Item
                        name='drugCount'
                        rules={[
                          {
                            required: true,
                            message: '请输入必填项',
                          },
                          {
                            pattern: /^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/,
                            message: '请输入正确的数量',
                          },
                        ]}
                        noStyle
                      >
                        <Input
                          ref={slRef}
                          style={{ flex: 1 }}
                          onChange={(e) => {
                            const drugCount: any = e.target.value  //每次用量
                            const doseUnit = form.getFieldValue('doseUnit') //剂量单位
                            const normalUsemethod = form.getFieldValue('normalUsemethod') //用法
                            const normalDose = form.getFieldValue('normalDose') //每次用量
                            const doseFixJDJZ = (normalDose > 0 && (normalUsemethod?.indexOf("静滴") >= 0 || normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
                            const doseFixWH = (normalDose > 0 && normalUsemethod?.indexOf("雾化") >= 0) ? true : false;
                            const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS]
                            const doseConvert = Number(current?.doseConvert) != -1 && Number(current?.doseConvert) || 1

                            let useDays: any = 0
                            let splitUseDays: any = 0
                            if (autoChangePriceAfter) {
                              if (drugCount && NumberPattern.test(drugCount) && current?.frequencyCalc && doseUnit != '适量') {
                                if (settings?.[Checks.MLKG] == 1) {
                                  if (!doseUnit) {
                                    useDays = form.getFieldValue('useDays')
                                    splitUseDays = form.getFieldValue('useDays')
                                  } else {
                                    useDays = getNewAutoChangePriceUseDays('drugCount', selectData, doseUnit, doseFixJDJZ, doseFixWH, drugCount, current?.frequencyCalc, normalDose, flag)
                                    splitUseDays = getNewAutoChangePriceSplitUseDays('drugCount', selectData, doseUnit, doseFixJDJZ, doseFixWH, drugCount, current?.frequencyCalc, normalDose, flag)
                                  }
                                } else {
                                  useDays = getOldAutoChangePriceUseDays('drugCount', doseFixJDJZ, drugCount, current?.frequencyCalc, normalDose, doseConvert)
                                  splitUseDays = getOldAutoChangePriceSplitUseDays('drugCount', doseFixJDJZ, drugCount, current?.frequencyCalc, normalDose)
                                }
                              }

                              const realUseDays: any = current?.splitTag == 1 ? splitUseDays : useDays
                              const data: any = {
                                ...current,
                                ...form.getFieldsValue(),
                                useDays: realUseDays == 'Infinity' ? 1 :
                                  Math.floor(
                                    realUseDays < 1 ? 1 : realUseDays
                                  ) || 1,
                                drugCount: drugCount,
                              }
                              setCurrent(data)
                            }
                          }}
                        />
                      </Form.Item>
                      <Form.Item name='accountUnit' noStyle>
                        {/* {settings?.[142] == 1 ?
                          <Select className={styles.doseUnitSelect}
                            onClick={() => {
                              if (material?.materialsCatalogId) {
                                getAccountUnitData(material)
                              }
                            }}
                          >
                            {accountUnitData?.map((item: any) => (
                              <Select.Option key={item.name} value={item.name}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select> : */}
                        <RecipeItemFieldInput
                          field='accountUnit'
                          disabled={settings?.[142] == 1 ? true : false}
                          noSize
                          style={{ width: 53, height: 32 }}
                        />
                      </Form.Item>
                    </Row>
                  </Form.Item>
                </Col>
              </>
            )}
            {discountFlag ? (
              <>
                <Col span={12}>
                  <Form.Item
                    {...layout}
                    name='originalPrice'
                    label='折前单价'
                    {...required}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    {...layout}
                    name='retailPrice'
                    label='折后单价'
                    rules={[
                      {
                        pattern: new RegExp(/^[0-9]+([.]{1}[0-9]+){0,1}$/),
                        message: '请输入数字',
                      },
                      { required: true, message: '请输入必填项' },
                    ]}
                  >
                    <Input
                      disabled={!allowedToChangePrice}
                      onChange={(v) => {
                        const retailPrice = v?.target?.value
                        const originalPrice = form.getFieldValue('originalPrice')
                        const discount =
                          retailPrice && originalPrice && Number(originalPrice) !== 0
                            ? (Number(retailPrice) / Number(originalPrice) * 100)?.toFixed(0)
                            : '0.00000'
                        form.setFieldsValue({ discount })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    {...layout}
                    name='discount'
                    label='折扣%'
                    rules={[
                      {
                        pattern: /^[1-9]\d*$/,
                        message: '请输入大于0的整数',
                      },
                      { required: true, message: '请输入必填项' },
                    ]}
                  >
                    <Input
                      disabled={!allowedToChangePrice}
                      onChange={(v) => {
                        const discount: any = v?.target?.value
                        const originalPrice = form.getFieldValue('originalPrice')
                        const retailPrice =
                            originalPrice && discount
                            ? (
                                (originalPrice ? Number(originalPrice) : 0) *
                                (discount ? Number(discount / 100) : 0)
                              )?.toFixed(5)
                            : '0.00000'
                        form.setFieldsValue({
                          retailPrice: retailPrice,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>{' '}
              </>
            ) : (
              <Col span={12}>
                <Form.Item
                  {...layout}
                  name='retailPrice'
                  label='单价'
                  {...required}
                >
                  <Input disabled={!allowedToChangePrice} />
                </Form.Item>
              </Col>
            )}

            {!isTcmRecipeCategory(category) && (
              <Col span={24}>
                <Form.Item
                  {...layout}
                  name='remark'
                  label='备注'
                  rules={[
                    {
                      max: 200,
                      message: '最长200位',
                    },
                  ]}
                >
                  <TextArea showCount maxLength={200} rows={3} />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={20}>
            <Col span={12}>
              <Button
                onClick={(e) => {
                  form.resetFields()
                  onCancel && onCancel(e)
                }}
                style={{ float: 'right' }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                id='buttonId'
                type='primary'
                loading={loading}
                style={{ float: 'left' }}
                onClick={form.submit}
              >
                保存（空格）
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title='可选单位'
        className={styles.split}
        visible={!!isSplitModalVisibleMaterialsBean}
        onCancel={() => {
          setIsSplitModalVisibleMaterialsBean(null)
        }}
        footer={null}
      >
        <Space direction='vertical'>
          <Button
            type='primary'
            onClick={() => {
              setIsSplitModalVisibleMaterialsBean(null)
              setTimeout(() => {
                const days = isSplitModalVisibleMaterialsBean?.useDays
                const useDays = days && days != -1 ? days : 1
                setCurrent({
                  ...isSplitModalVisibleMaterialsBean,
                  splitTag: 1,
                  useDays: useDays,
                  retailPrice: isSplitModalVisibleMaterialsBean?.splitPrice,
                  originalPrice: isSplitModalVisibleMaterialsBean?.splitPrice,
                  accountUnit: isSplitModalVisibleMaterialsBean?.splitUnit,
                  discount: 100,
                })
                if (isTcmRecipeCategory(category)) {
                  countPerTipRef?.current?.select()
                } else {
                  slRef?.current?.select()
                }
              }, 300)
            }}
          >
            <span
              style={{
                backgroundColor: theme.pn,
                borderRadius: 999,
                color: theme.c1,
                lineHeight: '1rem',
                marginRight: 8,
                textAlign: 'center',
                width: '1rem',
              }}
            >
              1
            </span>
            {`${isSplitModalVisibleMaterialsBean?.splitPrice || ''}元/${isSplitModalVisibleMaterialsBean?.splitUnit || ''}`}
          </Button>
          <Button
            ref={buttonRef}
            type='primary'
            onClick={() => {
              setIsSplitModalVisibleMaterialsBean(null)
              const days = isSplitModalVisibleMaterialsBean?.useDays
              const useDays = days && days != -1 ? days : 1
              setTimeout(() => {
                setCurrent({
                  ...isSplitModalVisibleMaterialsBean,
                  useDays: useDays,
                  originalPrice: isSplitModalVisibleMaterialsBean?.retailPrice,
                  splitTag: 0,
                  discount: 100,
                })
                if (isTcmRecipeCategory(category)) {
                  countPerTipRef?.current?.select()
                } else {
                  slRef?.current?.select()
                }
              }, 300)
            }}
          >
            <span
              style={{
                backgroundColor: theme.pn,
                borderRadius: 999,
                color: theme.c1,
                lineHeight: '1rem',
                marginRight: 8,
                textAlign: 'center',
                width: '1rem',
              }}
            >
              2
            </span>
            {`${isSplitModalVisibleMaterialsBean?.retailPrice || ''}元/${isSplitModalVisibleMaterialsBean?.accountUnit || ''}`}
          </Button>
        </Space>
        <div className={styles.hint}>可键盘选择“1”或“2”</div>
      </Modal>
    </>
  )
}
